import { Link } from "react-router-dom";
import { Mail, Phone, MapPin, Clock, Shield } from "lucide-react";

const Footer = () => {
  return (
    <footer className="bg-slate-900 text-white py-16 pb-24 sm:pb-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="md:col-span-2">
            <img
              src="https://customer-assets.emergentagent.com/job_lead-capture-roof/artifacts/593h2yec_image.png"
              alt="LLDLS Smart Energy"
              className="h-12 mb-6"
            />
            <p className="text-slate-400 leading-relaxed mb-4">
              Experts en toiture et énergie solaire en Wallonie et Brabant Wallon. 
              Plus de 350 projets réalisés avec une note de 4.9/5 sur Google.
            </p>
            <div className="flex items-center gap-2 text-amber-500 mb-4">
              <Clock className="w-4 h-4" />
              <span className="text-sm font-medium">Intervention urgence sous 24h</span>
            </div>
            <div className="flex items-center gap-2 text-green-400">
              <Shield className="w-4 h-4" />
              <span className="text-sm font-medium">Garantie décennale AXA</span>
            </div>
          </div>

          {/* Contact */}
          <div>
            <h3 className="font-heading font-semibold text-lg mb-6">Contact</h3>
            <ul className="space-y-4">
              <li>
                <a
                  href="mailto:lldlsgroupe@gmail.com"
                  className="flex items-center gap-3 text-slate-400 hover:text-white transition-colors"
                >
                  <Mail className="w-5 h-5" />
                  lldlsgroupe@gmail.com
                </a>
              </li>
              <li>
                <a
                  href="tel:+3264232850"
                  className="flex items-center gap-3 text-slate-400 hover:text-white transition-colors"
                >
                  <Phone className="w-5 h-5" />
                  064/23.28.50
                </a>
              </li>
              <li>
                <div className="flex items-start gap-3 text-slate-400">
                  <MapPin className="w-5 h-5 flex-shrink-0 mt-0.5" />
                  <span>
                    Rue Albert 1er 46/8<br />
                    7134 Binche<br />
                    Belgique
                  </span>
                </div>
              </li>
            </ul>
          </div>

          {/* Links */}
          <div>
            <h3 className="font-heading font-semibold text-lg mb-6">Informations</h3>
            <ul className="space-y-3">
              <li>
                <a
                  href="#form"
                  className="text-slate-400 hover:text-white transition-colors"
                >
                  Demander un devis
                </a>
              </li>
              <li>
                <a
                  href="#primes"
                  className="text-slate-400 hover:text-white transition-colors"
                >
                  Primes Wallonie
                </a>
              </li>
              <li>
                <a
                  href="#faq"
                  className="text-slate-400 hover:text-white transition-colors"
                >
                  FAQ
                </a>
              </li>
              <li>
                <Link
                  to="/mentions-legales"
                  className="text-slate-400 hover:text-white transition-colors"
                >
                  Mentions légales
                </Link>
              </li>
              <li>
                <Link
                  to="/privacy"
                  className="text-slate-400 hover:text-white transition-colors"
                >
                  Politique de confidentialité
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Legal Info */}
        <div className="mt-10 pt-8 border-t border-slate-800">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 text-sm text-slate-500 mb-6">
            <div>
              <span className="text-slate-400 font-medium">Entreprise :</span> LLDLS SRL
            </div>
            <div>
              <span className="text-slate-400 font-medium">TVA :</span> BE0745.423.125
            </div>
            <div>
              <span className="text-slate-400 font-medium">Assurance :</span> Garantie décennale AXA
            </div>
            <div>
              <span className="text-slate-400 font-medium">Zone :</span> Wallonie & Brabant Wallon
            </div>
          </div>
        </div>

        {/* Bottom */}
        <div className="pt-6 border-t border-slate-800 flex flex-col sm:flex-row justify-between items-center gap-4">
          <p className="text-slate-500 text-sm">
            © {new Date().getFullYear()} LLDLS SRL. Tous droits réservés.
          </p>
          <p className="text-slate-500 text-sm">
            Experts toiture · Wallonie & Brabant Wallon
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
